import { Updater, AsyncState, loadedAsyncState, loadingAsyncState } from "widgets-for-react";
import { knowledgeSearch } from "../cmsPage/sharepointPageApi/sharepointPageApi";
import { KnowledgeArticlePageData, PageResult } from "../cmsPage/sharepointPageApi/types/pageData";

export type KnowledgeSearchResult = PageResult<KnowledgeArticlePageData>

export interface KnowledgeSearchState {
    query?: string
    page?: number
    result: AsyncState<KnowledgeSearchResult>
}

export const initialKnowledgeSearchState: (query?: string, page?: string) => KnowledgeSearchState = 
(query, page) => {
    const intPage = parseInt((page || '1'));
    return {
        result: query
            ? loadingAsyncState(() => knowledgeSearch(query || '', intPage))
            : loadedAsyncState<PageResult<KnowledgeArticlePageData>>({ Count: 0, PerPage: 10, Total: 0, Resources: [] }),
        query: query || '',
        page: intPage
    };
}

export const knowledgeSearchPageStateUpdaters = {
    updateSearchResult: (updater: Updater<AsyncState<KnowledgeSearchResult>>) =>
        (state: KnowledgeSearchState): KnowledgeSearchState => ({
            ...state,
            result: updater(state.result),
        }),
}